<template functional>
  <div class="qir-form-section-background-shapes__wrapper" />
</template>

<script>
export default {
  name: 'QirFormSectionBackgroundShapes'
}
</script>

<style lang="scss" scoped>
.qir-form-section-background-shapes__wrapper {
  position: absolute;
  z-index: 1;
  pointer-events: none;

  $width: (
    $above-desktop-xl: 2112px,
    $desktop-md: 1300px,
    $mobile: 660px
  );

  $height: (
    $above-desktop-xl: 1255px,
    $desktop-md: 1394px,
    $mobile: 1347px
  );

  $top: (
    $above-desktop-xl: -303px,
    $desktop-md: -497px,
    $mobile: -465px
  );

  $left: (
    $above-desktop-xl: -1135px,
    $desktop-md: -361px,
    $mobile: -185px
  );

  $background-image: (
    $above-desktop-xl:
      url('/images/qir/background-circular-shapes-desktop-min.png'),
    $desktop-md: url('/images/qir/background-circular-shapes-tablet-min.png'),
    $mobile: url('/images/qir/background-circular-shapes-mobile-min.png')
  );

  @include setStyleByBreakpoint('background-image', $background-image);
  @include setStyleByBreakpoint('left', $left);
  @include setStyleByBreakpoint('top', $top);
  @include setStyleByBreakpoint('width', $width);
  @include setStyleByBreakpoint('height', $height);
}
</style>
